/**
 * Official Noah+Rayn house mark — uses the original logo artwork (PNG with
 * transparent background), cropped to the icon only. Color is preserved as-is
 * from the brand artwork; sizing is controlled via the className prop.
 */
export const BrandMark = ({ className = "", alt = "Noah+Rayn", ...rest }) => (
  <img
    src="/brand-mark.png"
    alt={alt}
    className={`object-contain ${className}`}
    draggable={false}
    {...rest}
  />
);
